/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  TerminationService,
  Wealthlane_AwardService_Dtos_Response_ResponseDto,
} from '../../services/wealthlane-award-services';

const usePostTerminationParticipantV2 = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_AwardService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        TerminationService.postApiAwardApiAppTerminationTerminateParticipant(payload)
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          void queryClient.invalidateQueries('getCustomerParticipantList');
          closeModal();
          toast.success(<ToastComponent label='Success' message={`Participant Terminated.`} />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostTerminationParticipantV2;
